<template>
  <v-btn
    v-if="toolBarStatus == 'edit'"
    class="my-2"
    depressed
    block
    small
    @click="previewPost"
  >
    <span class="font-weight-bold">{{ previewBtnTxt }}</span>
  </v-btn>
  <v-btn
    v-else-if="toolBarStatus == 'comment' && mode == 'readonly'"
    class="my-2"
    depressed
    block
    small
    @click="previewPost"
  >
    <span class="font-weight-bold">{{ previewBtnTxt }}</span>
  </v-btn>
  <v-btn
    v-else-if="toolBarStatus == 'comment'"
    depressed
    block
    @click="previewPost"
  >
    <span class="font-weight-bold">{{ previewBtnTxt }}</span>
  </v-btn>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    postId: {
      type: Number,
      required: true
    },
    mode: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      toolBarStatus: (state) => state.PostEditor.toolBarStatus
    }),
    previewBtnTxt () {
      if (this.mode === 'readonly') {
        return 'プレビュー'
      } else {
        return '保存してプレビュー'
      }
    }
  },
  methods: {
    previewPost () {
      if (this.mode === 'readonly') {
        window.open('/preview/' + this.postId, '_blank')
      } else {
        this.openPreviewPostAfterUpdate()
      }
    },
    openPreviewPostAfterUpdate: async function () {
      await this.$store.dispatch('PostEditor/updatePost')
      window.open('/preview/' + this.postId, '_blank')
    }
  }
}
</script>
